<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <v-layout row wrap>
        <v-flex xs12>
            <v-btn
                    color="primary"
                    class="new-dashboard-btn"
                    @click="createDashboard"
            >
                New Dashboard
            </v-btn>
        </v-flex>
        <v-flex xs12>
            <v-data-table
                class="elevation-1"
                :headers="headers"
                :items="dashboards"
                :rows-per-page-items="rowsPerPageItems"
                :loading="dashboardLoading"
            >
                <template v-slot:items="props">
                    <td>{{ props.item.name }}</td>
                    <td>{{ props.item.organizationName }}</td>
                    <td>
                        <v-chip
                                :key="keyword"
                                disabled
                                v-for="keyword in props.item.keywords"
                                label
                                color="primary"
                                text-color="white"
                        >
                            <span class="zawgyi">{{ keyword | textLowerCase | zgtext }}</span>
                        </v-chip>
                    </td>
                    <td>
                        <v-icon
                                small
                                @click="editDashboard(props.item)"
                        >edit
                        </v-icon>
                        &nbsp;
                        <v-icon
                                small
                                @click="removeDashboard(props.item.externalId)"
                        >delete
                        </v-icon>
                    </td>
                </template>
            </v-data-table>
        </v-flex>

        <v-dialog
                v-model="dashboardDialog"
                width="500"
        >
            <v-card>
                <v-card-title
                        class="headline"
                        primary-title
                >
                    Add New Dashboard
                </v-card-title>
                <v-card-text>
                    <v-form>
                        <v-container>
                            <v-layout row wrap>
                                <v-flex xs12>
                                    <v-text-field
                                            v-model="dashboard.name"
                                            label="Name"
                                    ></v-text-field>
                                </v-flex>
                                <v-flex xs12>
                                    <span>Keywords </span>
                                    <v-chip
                                            :key="keyword"
                                            v-for="keyword in dashboard.keywords"
                                            label
                                            color="primary"
                                            text-color="white"
                                            close
                                            @input="removeKeyword(keyword)"
                                    >
                                        <span class="zawgyi">
                                            {{ keyword | textLowerCase | zgtext }}
                                        </span>
                                    </v-chip>
                                </v-flex>
                                <v-flex xs9>
                                    <v-text-field
                                            v-model="enterKeyword"
                                            label="Keyword"
                                            :error-messages="keywordErrMsg"
                                    ></v-text-field>
                                </v-flex>
                                <v-flex xs3>
                                    <v-btn
                                            color="primary"
                                            @click="addKeyword"
                                    >Add
                                    </v-btn>
                                </v-flex>
                                <v-flex xs12>
                                    <v-select
                                        v-model="dashboard.organizationId"
                                        :items="organizations"    
                                        :disabled="!(isSuperAdmin || isBindezAdmin)"
                                        item-text="displayName"
                                        item-value="uuid"
                                        label="Select Organization"
                                    ></v-select>
                                </v-flex>
                            </v-layout>
                        </v-container>
                    </v-form>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                            color="error"
                            flat
                            @click="dashboardDialog = false"
                    >
                        Cancel
                    </v-btn>
                    <v-btn
                            color="primary"
                            flat
                            @click="save"
                    >
                        Save
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-layout>
</template>

<script>
    import { mapActions, mapState } from "vuex";
    import { UserService } from '../services/user.services';
    import { fontService } from '../services/font.services';
    import keywords from '../mixins/keywords';
    import current_user from "../mixins/current_user";

    const defaultDashboard = {
        name: '',
        keywords: [],
        organizationId: null
    };

    export default {
        mixins: [ keywords, current_user ],

        data() {
            return {
                headers: [
                    {
                        text: 'Name',
                        value: 'name',
                        sortable: false
                    },
                    {
                        text: 'Organization',
                        value: 'organizationName',
                        sortable: false
                    },
                    {
                        text: 'Keywords',
                        value: 'keywords',
                        sortable: false
                    },
                    {
                        text: 'Actions',
                        value: 'name',
                        sortable: false
                    }
                ],
                rowsPerPageItems: [50],
                dashboardDialog: false,
                dashboard: {
                    name: '',
                    keywords: [],
                    organizationId: null
                },
                enterKeyword: '',
                editDashboardId: null,
                keywordErrMsg: []
            }
        },

        methods: {
            createDashboard() {
                this.resetForm();
                this.dashboardDialog = true;
                this.editDashboardId = null;

                this.dashboard = Object.assign({}, defaultDashboard,
                    { organizationId: !(this.isSuperAdmin || this.isBindezAdmin) 
                        ? this.currentUser.organization.uuid 
                        : null });
            },

            addKeyword() {
                var new_keyword = this.enterKeyword.trim().toLowerCase();

                if (!new_keyword) {
                    this.keywordErrMsg = [ "Keyword must not be empty" ];
                    return;
                }

                new_keyword = this.isZawgyi(new_keyword)
                    ? fontService.convertToUni(new_keyword)
                    : new_keyword;

                const exists = this.dashboard.keywords
                    .findIndex(kw => kw.toLowerCase() === new_keyword) !== -1;

                if (!exists) {
                    this.dashboard.keywords.push(new_keyword);
                    this.enterKeyword = '';
                    this.keywordErrMsg = [];
                } else {
                    this.keywordErrMsg = [ "Keywords must be unique" ];
                }
            },

            save() {
                if (this.isValid()) {
                    const new_dashboard = {
                        name: fontService.convertToUni(this.dashboard.name),
                        organizationId: this.dashboard.organizationId,
                        keywords: [ ...this.dashboard.keywords ]
                    };

                    const clean = () => {
                        this.fetchDashboards();
                        this.getAdminDashboards();

                        this.resetForm();
                        this.dashboardDialog = false;
                    };

                    if (this.editDashboardId) {
                        this.updateDashboard({ 
                            id: this.editDashboardId, 
                            dashboard: new_dashboard 
                        })
                        .then(clean);
                        this.$ua.trackEvent('UpdateDashboard', 'click', 
                            `${this.currentUser.username || 'User'} updated ${this.editDashboardId} with payload ${JSON.stringify(new_dashboard, null, 2)}`);
                    } else {
                        this.saveDashboard(new_dashboard).then(clean);
                        this.$ua.trackEvent('CreateDashboard', 'click',
                            `${this.currentUser.username || 'User'} created ${JSON.stringify(new_dashboard, null, 2)}`);
                    }
                } else {
                    alert('Must enter all fields!')
                }
            },

            resetForm() {
                this.dashboard = Object.assign({}, defaultDashboard);
                this.enterKeyword = '';
                this.keywordErrMsg = [];
            },

            removeKeyword(keyword) {
                const index = this.dashboard.keywords.indexOf(keyword);
                if (index !== -1) this.dashboard.keywords.splice(index, 1);
            },

            removeDashboard(dashboardId) {
                if (confirm('Are you sure to delete this dashboard?')) {
                    this.deleteDashboard(dashboardId)
                        .then(() => {
                            this.fetchDashboards();
                            this.getAdminDashboards();
                        });
                    this.$ua.trackEvent('DeleteDashboard', 'click',
                        `${this.currentUser.username || 'User'} deleted ${dashboardId}`);
                }
            },

            editDashboard(old) {
                this.editDashboardId = old.externalId

                this.dashboard = {
                    name: old.name,
                    keywords: [...old.keywords],
                    organizationId: old.organizationId
                };

                this.dashboardDialog = true;
            },

            getAdminDashboards() {
                if (this.isCurrentUserAdmin) {
                    this.fetchAdminDashboards();
                }
            },

            isValid() {
                return !!this.dashboard.name
                    && ( !!this.dashboard.keywords && this.dashboard.keywords.length > 0 )
                    && ( !this.isCurrentUserAdmin || !!this.dashboard.organizationId )
            },

            ...mapActions('dashboards', [
                'fetchDashboards',
                'fetchAdminDashboards',
                'deleteDashboard',
                'saveDashboard',
                'updateDashboard'
            ]),

            isZawgyi(txt) {
                return fontService.detect(txt) === 'zawgyi';
            }
        },

        computed: {
            ...mapState('dashboards', [
                'dashboards',
                'adminDashboards',
                'dashboardLoading'
            ]),

            ...mapState('organizations', ['organizations']),

            currentUser() {
                return UserService.getCurrentUser();
            },

            isCurrentUserAdmin() {
                return this.currentUser.role === 'ROLE_ADMIN';
            }
        },

        watch: {
            dashboardDialog() {
                this.keywordErrMsg = [];
                this.enterKeyword = '';
            }
        }
    }
</script>

<style scoped>
    .new-dashboard-btn {
        margin-left: 0;
        margin-right: 0;
    }
</style>
